import { useQuery } from "@tanstack/react-query"

import { getSuscripcion } from "../services/suscripcion.service";

export const useSuscripcion = () => {

    const suscripcionQuery = useQuery({
        queryKey: ['suscripcion'],
        queryFn: () => getSuscripcion(),
        staleTime: 0, // null
    });

    return {
        suscripcionQuery,
    }
}